import { SUPPORT_PAGE_ENDPOINT } from "../../../constants";
import { useAuthContext } from "../../../context/authContext";
import { GetStartedLink } from "../../Navigation/GetStartedLink";
import { PiCalculator, PiPackage, PiQuestion } from "react-icons/pi";
export function GetStarted() {
  const { state: authState } = useAuthContext();

  const supportLink = buildSupportLink(
    SUPPORT_PAGE_ENDPOINT,
    authState.me?.email,
    authState.me?.name
  );

  const items = [
    {
      title: "Get a Quote",
      description: "Quickly get an accurate shipment quote.",
      icon: PiCalculator,
      bgColor: "bg-slate-100",
      iconColor: "text-[#0052FF]",
      link: "/dashboard/quote",
    },
    {
      title: "Book a Shipment",
      description: "Easily schedule your shipment with a few clicks.",
      icon: PiPackage,
      bgColor: "bg-slate-100",
      iconColor: "text-[#0052FF]",
      link: "/dashboard/ship",
    },
    {
      title: "Get Help",
      description: "Contact support for assistance anytime.",
      icon: PiQuestion,
      bgColor: "bg-slate-100",
      iconColor: "text-[#0052FF]",
      link: supportLink,
      external: true,
    },
  ];

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item, i) => (
        <GetStartedLink key={i} item={item} />
      ))}
    </ul>
  );
}

function buildSupportLink(baseUrl, email, name) {
  const url = new URL(baseUrl);

  if (email) url.searchParams.set("email", email);
  if (name) url.searchParams.set("name", name);

  return url.toString();
}
